import React, { FC } from 'react';
// mui components
import { Button, Grid, Tooltip } from '@mui/material';
// controllers
import OutlinedInputController from 'controllers/outlined-input-controller';
// types
import { LinkedItemCardProps } from '../../types';
import { LagTypeEnum } from 'redux-store/api/company';
// icons
import UnlinkedIcon from 'assets/icons/buttons/unlink.svg';
import LinkedIcon from 'assets/icons/linked.svg';
// styles
import { styles } from './styles';

const LinkedItemCard: FC<LinkedItemCardProps> = ({ field, index, lagType, showAction, remove }) => {
  const getLagDaysName = () => {
    if (lagType === LagTypeEnum.MAINTAIN) {
      return `linkedItems.${index}.workDaysDifference`;
    }

    return `linkedItems.${index}.lagDays`;
  };

  const startIcon = field.isLinked ? (
    <Tooltip title="Unlink item" placement="right">
      <UnlinkedIcon />
    </Tooltip>
  ) : (
    <Tooltip title="Link item" placement="right">
      <LinkedIcon />
    </Tooltip>
  );

  return (
    <Grid sx={styles.tableCeil}>
      <Grid sx={styles.name}>
        <OutlinedInputController
          readOnly
          fullWidth
          withError
          sxControl={styles.controllerHidden}
          defaultValue={field.name}
          name={`linkedItems.${index}.name`}
          placeholder="E.g. Building Permit"
        />

        <Tooltip title={field?.name} placement="right">
          <Grid sx={styles.nameWrapper}>{field?.name}</Grid>
        </Tooltip>
      </Grid>

      <Grid sx={styles.lagDays}>
        <OutlinedInputController
          readOnly
          fullWidth
          withError
          sxControl={styles.controller}
          name={getLagDaysName()}
          placeholder="E.g. 2"
        />
      </Grid>

      <Grid sx={styles.date}>
        <OutlinedInputController
          readOnly
          fullWidth
          withError
          sxControl={styles.controllerHidden}
          name={`linkedItems.${index}.startDate`}
          placeholder="E.g. Building Permit"
        />

        <Tooltip title={field?.startDate} placement="right">
          <Grid sx={styles.nameWrapper}>{field?.startDate}</Grid>
        </Tooltip>
      </Grid>

      <Grid sx={styles.date}>
        <OutlinedInputController
          readOnly
          fullWidth
          withError
          sxControl={styles.controllerHidden}
          name={`linkedItems.${index}.endDate`}
          placeholder="E.g. Building Permit"
        />

        <Tooltip title={field?.endDate} placement="right">
          <Grid sx={styles.nameWrapper}>{field?.endDate}</Grid>
        </Tooltip>
      </Grid>

      {showAction && (
        <Grid sx={styles.actions}>
          <Button
            variant="outlined"
            startIcon={startIcon}
            sx={styles.actionsButton}
            onClick={() => remove(index)}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default LinkedItemCard;
